import { callApi } from './config/callApi'

export const referrals = async (): Promise<any> => {
  return callApi({
    method: 'get',
    url: '/referals',
  })
}
